export const getAuthUser = (value: any = null) => useState<any>('auth/user', () => value)
export const getAuthRoles = (value: any = null) => useState<any>('auth/roles', () => value)
export const getAllRoles = (value: any) => useState<any>('roles', () => value)